<template>
   <div class="page-content">
      <h1 class="page-title">{{ $locale("endUserCustomizePage.sideMenu") }}</h1>
      <el-form
        class="egl-elm egl-detail"
        :model="form"
        label-position="top"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item :label="$locale('endUserCusomizePage.displayName')" prop="displayName">
              <el-input v-model="form.name" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item :label="$locale('endUserCusomizePage.transferOldName')">
              <GroupBtns :parentValue.sync="form.oldMemberMigrate" />
            </el-form-item>
          </el-col>
        </el-row>
        <!-- newCL button display -->
        <el-row>
          <el-form-item label="new CL Display" prop="clCinemas">
            <el-col :span="6">
              <RemoteSelectV2
                type="cinema"
                :list="comCinemaList"
                v-model="form.clCinemas"
                :isMultiple="true"
                :formValue.sync="form.clCinemas"
                @setList="arr => comCinemaList = arr"
              />
            </el-col>
          </el-form-item>
        </el-row>
        <!-- CCM button display -->
        <el-row>
          <el-form-item label="CCM Display" prop="ccmCinemas">
            <el-col :span="6">
              <RemoteSelectV2
                type="cinema"
                :list="comCinemaList"
                v-model="form.ccmCinemas"
                :isMultiple="true"
                :formValue.sync="form.ccmCinemas"
                @setList="arr => comCinemaList = arr"
              />
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item :label="$locale('endUserCusomizePage.isShowNumber')">
              <el-select v-model="form.isShowNumber">
                <el-option :label="$locale('global.do')" :value="true"></el-option>
                <el-option :label="$locale('global.donot')" :value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <p>{{ $locale('endUserCusomizePage.colorStyle') }}</p>
          <el-form-item :label="$locale('endUserCusomizePage.themeColor')" prop="themeColor">
            <div class="color-picker-cinemaWebsite">
                <div class="bg" :style="{backgroundColor: form.mainColor }">
                  <el-color-picker v-model="form.mainColor" />
                </div>
                <span>{{form.mainColor}}</span>
              </div>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
              <el-form-item
              :label="$locale('cinemaWebsite.websiteInformation.formItem.favicon')"
              prop="favicon"
              class="upload"
              >
              <UploadContainer
                  :type="'B'"
                  :placeholder="$locale('cinemaWebsite.websiteInformation.formItem.favicon.placeholder')"
                  :imageList="[form.favicon]"
                  @onSuccess="({response}) => uploadSuccess(response)"
                  @onDelete="deleteImg"
              ></UploadContainer>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
					<el-col :span="12">
						<el-form-item
							:label="$locale('cinemaWebsite.websiteInformation.formItem.metadata')"
							prop="metadata"
						>
							<el-input
								type="textarea"
								:rows="5"
								:placeholder="$locale('cinemaWebsite.websiteInformation.formItem.metadata.placeholder')"
								v-model="form.metadata" />
						</el-form-item>
					</el-col>
				</el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="URL" prop="url">
              {{ form.url }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="24" style="margin-top:40px;text-indent: 230px;">
          <el-button style="width: 200px;" class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm2") }}</el-button>
        </el-col>
      </el-row>
    </div>
</template>
<script>
import GroupBtns from '@/components/common/GroupBtns/GroupBtns.vue'
import UploadContainer from "@/components/common/UploadContainer";
import { getEndUserCustomizeService, updateEndUserCustomizeService } from '@/helpers/service/api/membership'
import countDownAlert from "@/utils/countDownAlert";
import RemoteSelectV2 from '@/components/common/RemoteSelect-v2';
import { getCinemaListMap } from '@/helpers/service/api/common';
import form from '@/helpers/locale/ja/form';

export default {
  created() {
    this.getEndUserDetail()
  },
  mounted() {
    getCinemaListMap({
      brandId: window.localStorage.getItem('brandId'),
      field: ['id', 'name'],
      page: 0,
      pageSize: 20,
    }).then((res) => {
      if (res.data && res.data.data.length > 0) {
        this.comCinemaList = res.data.data;
      }
      // 如果有设置过cinemaId
      const allCinemaIds = this.$_.uniq([...this.form.clCinemas, ...this.form.ccmCinemas]);
      if (allCinemaIds.length > 0) {
        getCinemaListMap({
          brandId: window.localStorage.getItem('brandId'),
          field: ['id', 'name'],
          ids: allCinemaIds,
          page: 0,
          pageSize: 20,
        }).then((cinema) => {
          if (res.data && res.data.data.length > 0) {
            this.comCinemaList = this.$_.uniqBy([...cinema.data.data, ...this.comCinemaList], 'id');
          }
        })
      }
      
    })
  },
  data() {
    return {
      form: {
        name: '',
        oldMemberMigrate: '',
        isShowNumber: false,
        mainColor: '#000',
        favicon: '',
        metadata: '',
        url: '',
        clCinemas: null,
        ccmCinemas: null,
      },
      comCinemaList: [],
    }
  },
  methods: {
    getEndUserDetail() {
      getEndUserCustomizeService({
        brandId: window.localStorage.getItem('brandId')
      }).then(res => {
        if (res.data) {
          this.form = res.data
        }
      })
    },
    uploadSuccess(res) {
				if (res.success) {
					this.form = { ...this.form, favicon: res.data };
				}
		},
		deleteImg() {
			this.form = { ...this.form, favicon: "" };
		},
    save_fn() {
        updateEndUserCustomizeService({
          brandId: window.localStorage.getItem("brandId"),
          favicon: this.form.favicon,
          mainColor: this.form.mainColor,
          metadata: this.form.metadata,
          name: this.form.name,
          oldMemberMigrate: this.form.oldMemberMigrate,
          isShowNumber: this.form.isShowNumber,
          clCinemas: this.form.clCinemas,
          ccmCinemas: this.form.ccmCinemas,
        }).then(res => {
          if (res.success) {
            countDownAlert({ content: this.$locale("global.updateSuccessfully"), callback: () => {
              this.getEndUserDetail()
            }})
          }
        })
    },
  },
  components: {
    GroupBtns,
    UploadContainer,
    RemoteSelectV2,
  }
}
</script>